import { Navigate, useParams } from 'react-router';

// Tecton
import { useGetDatasets } from '../../../api/datasets';
import { useGetFcos } from '../../../api/fcos';
import { DatasetFCO, FCOFields, WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { useUserSettings } from '../../context/UserSettingsContext';
import DataSetOverview from './DataSetOverview';

// @tecton
import { Loading, ViewLayout } from '@lithos';

const DatasetContainer = () => {
  const { workspace } = useUserSettings();
  const { name } = useParams();
  const { data, isLoading } = useGetFcos(workspace ?? '', {
    select: (data: WorkspaceFCOContainer) => {
      return {
        idToFcoMap: data?.idToFcoMap,
      };
    },
  });

  const { data: dataSetsData, isLoading: isLoadingDataset } = useGetDatasets(workspace ?? '');

  if (isLoading || isLoadingDataset) {
    return <Loading />;
  }

  const fco = dataSetsData?.data.find((fcoDataset: DatasetFCO) => {
    return fcoDataset[FCOFields.NAME] === name;
  });

  if (!fco) {
    // We switched workspaces and didn't find the datasets name, so we redirect them to the datasets lists
    return <Navigate to={`../${workspace}/datasets`} />;
  }

  const headerProps = {
    breadcrumbs: {
      root: { label: workspace ?? '', url: `/repo/${workspace}` },
      items: [{ label: 'Datasets', url: `/repo/${workspace}/datasets` }, { label: name }],
    },
    title: name,
    subtitle: fco?.[FCOFields.DESCRIPTION] ?? 'No description provided.',
  };

  return <ViewLayout header={headerProps} content={<DataSetOverview fco={fco} idToFcoMap={data.idToFcoMap} />} />;
};

export default DatasetContainer;
